import React from 'react';
import {SelectBox} from 'src/design/atoms/SelectBox';
import {useListEntityFieldSelectOptionsQuery} from 'src/redux/queries/auditLog';
import type {ISelectOption} from 'src/types/Form';

export interface EntityFieldSelectProps {
  entityType: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const EntityFieldSelect: React.FC<EntityFieldSelectProps> = ({
  entityType,
  value,
  onChange,
  disabled = false,
}) => {
  const {data: entityFields, isLoading} = useListEntityFieldSelectOptionsQuery(
    entityType,
    {
      skip: !entityType,
    }
  );

  const handleEntityFieldChange = (value: string): void => {
    onChange(value);
  };

  const entityFieldOptions: ISelectOption[] =
    entityFields?.data?.map(option => ({
      id: option.label ?? '',
      label: option.label?.splitUppercase() ?? '',
    })) ?? [];

  return (
    <SelectBox
      label="Entity Field"
      options={entityFieldOptions}
      value={value}
      disabled={disabled || isLoading || !entityType}
      onSelectChangeCallback={handleEntityFieldChange}
    />
  );
};
